import script from "./Name.vue?vue&type=script&setup=true&lang=js"
export * from "./Name.vue?vue&type=script&setup=true&lang=js"

import "./Name.vue?vue&type=style&index=0&id=df790c7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df790c7c"]])

export default __exports__